import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Io from '../../components/modules/io/Io';


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch);
}



function mapStateToProps(state) {
  const { io } = state;

  return {
    io
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Io);



// WEBPACK FOOTER //
// ./src/containers/components/Io.js